import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Logo from '../../assets/images/logo.png';
import LoadingSpinner from '../common/LoadingSpinner';
import { resetPassword } from '../../actions/auth';
import { authFormUpdate, authError, loginUser, registerUser } from '../../actions/auth';
import { setAccountPanel } from '../../actions/panels';

import Tabs from '../common/NavigationTabs';

let styles = {
    formHeaderTop: {
        marginTop: 15, 
        marginBottom: 15, 
        fontSize: 20,
        color: '#4b4b4b',
        fontWeight: '700', 
        textAlign: 'center',
        textTransform: 'uppercase'
    },
    informationPadding: {
      paddingHorizontal: 20
    },
    resetText: {
      color: 'black',
      fontWeight: '400',
      fontSize: 12,
      marginBottom: 15
    },
}

class ForgotPasswordPage extends React.Component {

    constructor(props) {
        super(props);

        this.onCancelButtonPress = this.onCancelButtonPress.bind(this);
        this.onResetPasswordButtonPress = this.onResetPasswordButtonPress.bind(this);

        this.state = {
           signInSelected: true, 
           registerSelected: false,
           setModalVisible: false
        };
    }

    componentDidMount(){
        // If they're logged in they shouldn't be here
        if(this.props.logged_in){
            // this.props.history.push('/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/account');
        }else{

        }

        // Above isn't currently needed. The link to bring the user to this page is only seen when not logged in, 
            // and if you try to access the page url directly (or any page directly) your login information is lost
    }

    onCancelButtonPress() {
        this.props.history.push('/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+'/account');
    }

    onResetPasswordButtonPress() {
        // perform basic error checking
        const { email, dispatch } = this.props;
        if (email === undefined || email.trim() == '') {
            dispatch(authError("E-mail cannot be blank."))
        }            
        else if (!email.match(/^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}\s*$/))
        {
            dispatch(authError("Please enter a valid e-mail address."))
        }
        else {
            dispatch(resetPassword(email, this.props.match.params.sitename, this.props.match.params.lid));
        }

    }
    
    render() {

        if ( this.props.loading ) {
            return (
                <LoadingSpinner />
            )
        }

        return (    
            <div className="breakpointContainer">
                <div className="login-section"> 
                    <img src={Logo} className="loginlogo" />

                    <div className="auth-selection-window">                  
                        <div style={styles.formHeaderTop}>Forgot Password?</div>
                    </div>

                    <div style={styles.informationPadding}>                  
                        <div style={styles.resetText}>Forgot your password? Enter your email address below and we'll send you instructions on resetting your password.</div>
                    </div>

                    <div>

                        {this.props.error != false && (
                            <div>
                                <p className="error-text">{this.props.error}</p>
                            </div>
                        )}

                        {this.props.success != false && (
                            <div>
                                <p className="success-text">{this.props.success}</p>
                            </div>
                        )}

                        <div className="input-email-window">
                            <input 
                                type="text"
                                className="text-field-input"
                                placeholder="Email"
                                value={this.props.email}
                                onChange={(e) => this.props.dispatch(authFormUpdate({ prop: 'email', value: e.target.value }))}
                            />
                        </div>
                    </div>

                    <div className="auth-selection-window">                  
                        <div className="auth-button">
                            <a  
                                className={'selected lessPadding'}
                                onClick={() => {
                                    this.onResetPasswordButtonPress()
                                }}
                            >
                                <p className={'selected-button-text'}>Reset&nbsp;Password</p>
                            </a>
                        </div>
                        <div className="auth-button">
                            <a
                                className={'selected lessPadding generic-cancel-button'}
                                onClick={() => {
                                    this.onCancelButtonPress()
                                }}
                            >
                                <p className={'selected-button-text'}>Cancel</p>
                            </a>
                        </div>
                    </div>
                </div>

                <Tabs 
                    lid={this.props.match.params.lid}
                    sitename={this.props.match.params.sitename}
                    section="account"
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        logged_in: state.auth.logged_in,
        email:state.auth.email, // I think we can share the email property here, whatever they had put in the sign in form is what they'll want to reset and if they make any changes, once they go back they'll probably be trying to get into that account
        acceptTerms: state.auth.acceptTerms,
        loading: state.auth.loading,
        error: state.auth.error,
        success: state.auth.success,
    };
};

export default connect(mapStateToProps)(ForgotPasswordPage);